import { createRoot } from "react-dom/client";
import { App } from "./ui/App.tsx";
import { boot, signedOut } from "./lib/store.ts";
import { setUnauthorizedHandler } from "./lib/api.ts";
import { navigate } from "./lib/router.ts";
import "./styles.css";

try {
  const theme = localStorage.getItem("majlis-theme");
  if (theme === "light" || theme === "dark") document.documentElement.dataset.theme = theme;
} catch { /* storage blocked */ }

setUnauthorizedHandler(() => {
  signedOut();
  if (!["/login", "/register", "/forgot"].includes(location.pathname)) navigate(`/login?next=${encodeURIComponent(location.pathname)}`, true);
});

createRoot(document.getElementById("root")!).render(<App />);
void boot();
